import { render, staticRenderFns } from "./PasswordModal.vue?vue&type=template&id=3cf2fecb&scoped=true"
import script from "./PasswordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordModal.vue?vue&type=style&index=0&id=3cf2fecb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2fecb",
  null
  
)

export default component.exports